<template>
  <div>
    <v-layout class="systock-breadcrump text-uppercase" align-center>
      <v-flex xs5>
        <v-breadcrumbs>
          <v-breadcrumbs-item>
            <h4>
              <v-icon left>mdi-map</v-icon>
              Mapeamento de Filiais
            </h4>
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-flex>
    </v-layout>

    <v-card flat>
      <v-tabs centered>
        <v-tab>
          <v-icon left>mdi-cart</v-icon>
          Mapa Compra
        </v-tab>

        <v-tab>
          <v-icon left>mdi-truck-delivery</v-icon>
          Mapa Separação
        </v-tab>

        <v-tab-item class="ma-0">
          <mapa-compra></mapa-compra>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <mapa-separacao></mapa-separacao>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import MapaCompra from "./MapaCompra.vue"
import MapaSeparacao from "./MapaSeparacao.vue"

export default {
  components: {
    MapaCompra,
    MapaSeparacao
  },
  name: "Acl",
  data() {
    return {
      atualizarApp: 0,
      atualizarPerm: 0,
      atualizarUsu: 0
    };
  },
  created() {
    this.Helpers.verificarToken();
  },
};
</script>

<style>

</style>
